<template>
  <div v-if="doormat" class="wrapper">
    <div class="doormat mx-auto">
      <h2 class="my-6">{{ doormat.title }}</h2>
      <v-row class="doormat-columns mx-0">
        <template v-for="(component, index) in doormat.components">
          <div v-if="component.name === 'doormat-community'" :id="component.name" :key="index" class="paragraph">
            <h2 class="h3 my-2">
              {{ component.title }}
            </h2>
            <section v-dompurify-html="component.content" />
            <a :href="`${links[0].href}`" target="_blank">
              <div class="link external">
                {{ links[0].text }}
              </div>
            </a>
          </div>
          <div v-if="component.name === 'doormat-kennis'" :id="component.name" :key="index" class="paragraph">
            <h3 class="h3 my-2">
              {{ component.title }}
            </h3>
            <section v-dompurify-html="component.content" />
            <a :href="`${links[1].href}`"
              ><div class="link">{{ links[1].text }}</div></a
            >
          </div>
          <div v-if="component.name === 'doormat-stel-vraag'" :id="component.name" :key="index" class="paragraph">
            <h3 class="h3 my-2">
              {{ component.title }}
            </h3>
            <section v-dompurify-html="component.content" />
          </div>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "~/axios";
import i18n from "~/i18n/index";

export default {
  name: "DoormatComponent",
  props: [],
  data() {
    return {
      doormat: null,
    };
  },
  computed: {
    ...mapGetters(["use_api_endpoint", "cms_api_endpoint"]),
    links() {
      return [
        {
          text: this.$i18n.locale === "nl" ? "Community edusources" : "Community edusources",
          href: "https://community-edusources.pleio.nl",
        },
        {
          text: this.$i18n.locale === "nl" ? "Kennis & expertise" : "Knowledge & expertise",
          href: `${this.use_api_endpoint}`,
        },
      ];
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.loadData();
    },
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const locale = i18n.locales.find((x) => x.code == i18n.locale).iso;
      const query = {
        query: `query {
            pages(filter: {  name: { _in: "search-edusources-nl"} }) {
              id
              name
              type
              translations(filter: { languages_code: { code: { _eq: "${locale}" } } }) {
                languages_code {
                  code
                }
                title
                subtitle
                content
              }
              components {
                item {
                  ... on components {
                    id
                    name
                    type
                    link
                    author
                    picture {
                      id
                    }
                    translations(filter: { languages_code: { code: { _eq: "${locale}"  } } }) {
                      link
                      title
                      content
                    }
                    components {
                      item {
                        ... on components {
                          id
                          name
                          type
                          link
                          author
                          picture {
                            id
                          }
                          translations(filter: { languages_code: { code: { _eq: "${locale}" } } }) {
                            link
                            title
                            content
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }`,
      };

      const url = this.cms_api_endpoint;
      const { data } = await axios.post(url, query, {
        headers: {
          authorization: null, // dont send bearer token because directus will check it and fail
        },
      });
      this.doormat = {
        title: data.data.pages[0].components[0].item.translations[0].title,
        components: data.data.pages[0].components[0].item.components.map((x) => {
          return {
            name: x.item.name,
            title: x.item.translations[0].title,
            content: x.item.translations[0].content,
          };
        }),
      };
    },
  },
};
</script>

<style lang="less" scoped>
@import "../variables";
.wrapper {
  margin-top: 30px;
  width: 100%;
  background-color: @light-grey;
  min-height: 260px;
}

.doormat {
  width: 100%;
  max-width: 1116px;
  padding-bottom: 40px;
}
.doormat-columns {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
}

@media (max-width: 940px) {
  .doormat-columns {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

.paragraph {
  margin-bottom: 20px;
}

a {
  text-decoration: none !important;
}
.link {
  cursor: pointer;
  padding-top: 12px;
  color: @green;
}
.link:hover {
  text-decoration: none !important;
  color: @green-hover-dark;
}
.external:after {
  content: url("data:image/svg+xml, %3Csvg width='28' height='22' viewBox='0 0 28 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 11.5C19.7348 11.5 19.4804 11.6054 19.2929 11.7929C19.1054 11.9804 19 12.2348 19 12.5V18.5C19 18.7652 18.8946 19.0196 18.7071 19.2071C18.5196 19.3946 18.2652 19.5 18 19.5H6C5.73478 19.5 5.48043 19.3946 5.29289 19.2071C5.10536 19.0196 5 18.7652 5 18.5V6.5C5 6.23478 5.10536 5.98043 5.29289 5.79289C5.48043 5.60536 5.73478 5.5 6 5.5H12C12.2652 5.5 12.5196 5.39464 12.7071 5.20711C12.8946 5.01957 13 4.76522 13 4.5C13 4.23478 12.8946 3.98043 12.7071 3.79289C12.5196 3.60536 12.2652 3.5 12 3.5H6C5.20435 3.5 4.44129 3.81607 3.87868 4.37868C3.31607 4.94129 3 5.70435 3 6.5V18.5C3 19.2956 3.31607 20.0587 3.87868 20.6213C4.44129 21.1839 5.20435 21.5 6 21.5H18C18.7956 21.5 19.5587 21.1839 20.1213 20.6213C20.6839 20.0587 21 19.2956 21 18.5V12.5C21 12.2348 20.8946 11.9804 20.7071 11.7929C20.5196 11.6054 20.2652 11.5 20 11.5Z' fill='%23008741'/%3E%3Cpath d='M15.9999 5.5H17.5799L11.2899 11.78C11.1962 11.873 11.1218 11.9836 11.071 12.1054C11.0203 12.2273 10.9941 12.358 10.9941 12.49C10.9941 12.622 11.0203 12.7527 11.071 12.8746C11.1218 12.9964 11.1962 13.107 11.2899 13.2C11.3829 13.2937 11.4935 13.3681 11.6154 13.4189C11.7372 13.4697 11.8679 13.4958 11.9999 13.4958C12.132 13.4958 12.2627 13.4697 12.3845 13.4189C12.5064 13.3681 12.617 13.2937 12.7099 13.2L18.9999 6.92V8.5C18.9999 8.76522 19.1053 9.01957 19.2928 9.20711C19.4804 9.39464 19.7347 9.5 19.9999 9.5C20.2652 9.5 20.5195 9.39464 20.707 9.20711C20.8946 9.01957 20.9999 8.76522 20.9999 8.5V4.5C20.9999 4.23478 20.8946 3.98043 20.707 3.79289C20.5195 3.60536 20.2652 3.5 19.9999 3.5H15.9999C15.7347 3.5 15.4804 3.60536 15.2928 3.79289C15.1053 3.98043 14.9999 4.23478 14.9999 4.5C14.9999 4.76522 15.1053 5.01957 15.2928 5.20711C15.4804 5.39464 15.7347 5.5 15.9999 5.5Z' fill='%23008741'/%3E%3C/svg%3E");
  vertical-align: sub;
}

.external-black:after {
  content: url("data:image/svg+xml, %3Csvg width='18' height='18' viewBox='0 0 20 22' fill='000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 11.5C19.7348 11.5 19.4804 11.6054 19.2929 11.7929C19.1054 11.9804 19 12.2348 19 12.5V18.5C19 18.7652 18.8946 19.0196 18.7071 19.2071C18.5196 19.3946 18.2652 19.5 18 19.5H6C5.73478 19.5 5.48043 19.3946 5.29289 19.2071C5.10536 19.0196 5 18.7652 5 18.5V6.5C5 6.23478 5.10536 5.98043 5.29289 5.79289C5.48043 5.60536 5.73478 5.5 6 5.5H12C12.2652 5.5 12.5196 5.39464 12.7071 5.20711C12.8946 5.01957 13 4.76522 13 4.5C13 4.23478 12.8946 3.98043 12.7071 3.79289C12.5196 3.60536 12.2652 3.5 12 3.5H6C5.20435 3.5 4.44129 3.81607 3.87868 4.37868C3.31607 4.94129 3 5.70435 3 6.5V18.5C3 19.2956 3.31607 20.0587 3.87868 20.6213C4.44129 21.1839 5.20435 21.5 6 21.5H18C18.7956 21.5 19.5587 21.1839 20.1213 20.6213C20.6839 20.0587 21 19.2956 21 18.5V12.5C21 12.2348 20.8946 11.9804 20.7071 11.7929C20.5196 11.6054 20.2652 11.5 20 11.5Z' fill='%23000'/%3E%3Cpath d='M15.9999 5.5H17.5799L11.2899 11.78C11.1962 11.873 11.1218 11.9836 11.071 12.1054C11.0203 12.2273 10.9941 12.358 10.9941 12.49C10.9941 12.622 11.0203 12.7527 11.071 12.8746C11.1218 12.9964 11.1962 13.107 11.2899 13.2C11.3829 13.2937 11.4935 13.3681 11.6154 13.4189C11.7372 13.4697 11.8679 13.4958 11.9999 13.4958C12.132 13.4958 12.2627 13.4697 12.3845 13.4189C12.5064 13.3681 12.617 13.2937 12.7099 13.2L18.9999 6.92V8.5C18.9999 8.76522 19.1053 9.01957 19.2928 9.20711C19.4804 9.39464 19.7347 9.5 19.9999 9.5C20.2652 9.5 20.5195 9.39464 20.707 9.20711C20.8946 9.01957 20.9999 8.76522 20.9999 8.5V4.5C20.9999 4.23478 20.8946 3.98043 20.707 3.79289C20.5195 3.60536 20.2652 3.5 19.9999 3.5H15.9999C15.7347 3.5 15.4804 3.60536 15.2928 3.79289C15.1053 3.98043 14.9999 4.23478 14.9999 4.5C14.9999 4.76522 15.1053 5.01957 15.2928 5.20711C15.4804 5.39464 15.7347 5.5 15.9999 5.5Z' /%3E%3C/svg%3E");
}

.v-btn {
  text-transform: none;
  color: @black;
  font-weight: 600;
  font-size: 14px;
  padding: 0 10px;
  justify-content: flex-start;
}
</style>
